module.exports = __webpack_public_path__ + "static/media/testimonialport1.155df136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonialport1.jpg
// module id = 465
// module chunks = 0